import { employmentGridFrag } from './user.types';

export const profileFrag = `
    id
    auth2fa
    username
    initials
    name
    surname
    titleBeforeName
    titleAfterName
    email
    sex
    roleName
    image
    employments {
        ${employmentGridFrag}
        serviceSettings {
            key
            data
            serviceId
        }
    }
    serviceWorkplaces {
        id
        name
        serviceId
    }
    msAccessToken
`;
